import * as React from 'react';
import { cn } from '../../lib/utils';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

const INPUT_BASE =
  'w-full rounded-lg bg-surface px-3 py-2 text-[13px] text-ink hairline outline-none transition focus:shadow-[inset_0_0_0_2px_var(--color-accent)] placeholder:text-faint';

export const SearchInput = ({
  value,
  onChange,
  placeholder = 'Search…',
  className,
}: SearchInputProps) => (
  <div className={cn('relative', className)}>
    <svg
      className="pointer-events-none absolute left-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-faint"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    >
      <circle cx="7" cy="7" r="4.5" />
      <path d="M10.5 10.5 14 14" />
    </svg>
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className={cn(INPUT_BASE, 'h-9 min-w-[240px] py-0 pl-9')}
    />
    {value && (
      <button
        type="button"
        onClick={() => onChange('')}
        title="Clear search"
        className="absolute right-2.5 top-1/2 -translate-y-1/2 text-[13px] text-faint transition hover:text-ink"
      >
        ×
      </button>
    )}
  </div>
);
